module.exports = __webpack_public_path__ + "img/icon24.928f929e.png";